import { Component } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { ContactService } from '../../contact/service/contact.service';
import { CorpInputComponent, CorpInputPhoneComponent, CorpLoadingComponent, CorpTextareaComponent } from '@corporate-tailwind/component';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'app-fp-contact',
    imports: [CommonModule, ReactiveFormsModule, CorpLoadingComponent, CorpInputComponent, CorpTextareaComponent, CorpInputPhoneComponent, TranslateModule],
    templateUrl: './fp-contact.component.html',
    styleUrl: './fp-contact.component.scss'
})
export class FpContactComponent {
formContact: FormGroup | null = null;

    constructor(
        public _contactService: ContactService
    ) {

        this.formContact = this._contactService.formGroup;
    }

    ngOnInit() {
        this._contactService.init();
    }

    save() {
        this._contactService.save();
    }

}